import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormInput,
  CFormSelect,
  CFormTextarea,
  CRow,
  CCol,
  CButton,
} from "@coreui/react";
import React, { useState } from "react";
import authInstance from "src/api/apiConfig";
import { Loader } from "src/services/const";
import { successAlert, errorAlert } from "src/utils/Swal";

const GuarantorReferences = () => {
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    pan: "",
    aadhar: "",
    address: "",
    pan1: "",
    aadhar1: "",
    address1: "",
    GuarantorName: "",
    fathersName: "",
    mobileNumber: "",
    GuarantorName1: "",
    fathersName1: "",
    mobileNumber1: "",
    refName: "",
    referencePhoneNumber: "",
    nameProfessional: "",
    phoneNumberProfessional: "",
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    switch (name) {
      case "pan":
      case "pan1":
        return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)
          ? ""
          : "Invalid PAN format (e.g., ABCDE1234F)";
      case "aadhar":
      case "aadhar1":
        return /^\d{12}$/.test(value) ? "" : "Aadhar number must be 12 digits";
      case "address":
      case "address1":
        return value.trim().length >= 10
          ? ""
          : "Address must be at least 10 characters";
      case "GuarantorName":
      case "GuarantorName1":
      case "refName":
      case "nameProfessional":
      case "fathersName":
      case "fathersName1":
        return value.trim() ? "" : "This field is required";
      case "mobileNumber":
      case "mobileNumber1":
      case "referencePhoneNumber":
      case "phoneNumberProfessional":
        return /^[6-9]\d{9}$/.test(value)
          ? ""
          : "Invalid mobile number (10 digits starting with 6-9)";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  const validateAll = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateAll()) {
      errorAlert("Validation Error", "Please fix the highlighted fields.");
      return;
    }

    setLoader(true);
    try {
      // Replace with your actual API endpoint
      const response = await authInstance.post(
        "/api/guarantor-references",
        formData
      );
      successAlert(
        "Success",
        "Guarantor and references submitted successfully!"
      );
      // Reset form after successful submission
      setFormData({
        pan: "",
        aadhar: "",
        address: "",
        pan1: "",
        aadhar1: "",
        address1: "",
        GuarantorName: "",
        fathersName: "",
        mobileNumber: "",
        GuarantorName1: "",
        fathersName1: "",
        mobileNumber1: "",
        refName: "",
        referencePhoneNumber: "",
        nameProfessional: "",
        phoneNumberProfessional: "",
      });
      setErrors({});
    } catch (error) {
      console.error("Submission error:", error);
      errorAlert(
        "Error",
        "Failed to submit guarantor details. Please try again."
      );
    } finally {
      setLoader(false);
    }
  };

  const handleReset = () => {
    setFormData({
      pan: "",
      aadhar: "",
      address: "",
      pan1: "",
      aadhar1: "",
      address1: "",
      GuarantorName: "",
      fathersName: "",
      mobileNumber: "",
      GuarantorName1: "",
      fathersName1: "",
      mobileNumber1: "",
      refName: "",
      referencePhoneNumber: "",
      nameProfessional: "",
      phoneNumberProfessional: "",
    });
    setErrors({});
  };

  return (
    <div>
      <CForm onSubmit={handleSubmit}>
        <CRow className="mb-3">
          <CCol md={12}>
            <div className="d-flex justify-content-center pt-5">
              <div
                style={{
                  fontSize: "16px",
                  color: "#000",
                  fontWeight: "600",
                }}
              >
                Guarantor and References
              </div>
            </div>
          </CCol>
        </CRow>

        {/* First Guarantor */}
        <CCard className="mb-4">
          <CCardHeader>First Guarantor Details</CCardHeader>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="GuarantorName"
                  label="Guarantor Name"
                  placeholder="Enter full name"
                  value={formData.GuarantorName}
                  onChange={handleChange}
                  invalid={!!errors.GuarantorName}
                  feedback={errors.GuarantorName}
                />
              </CCol>
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="fathersName"
                  label="Father's Name"
                  placeholder="Enter father's name"
                  value={formData.fathersName}
                  onChange={handleChange}
                  invalid={!!errors.fathersName}
                  feedback={errors.fathersName}
                />
              </CCol>
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="mobileNumber"
                  label="Mobile Number"
                  placeholder="Enter 10-digit mobile number"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  invalid={!!errors.mobileNumber}
                  feedback={errors.mobileNumber}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="pan"
                  label="PAN Number"
                  placeholder="Enter PAN (e.g., ABCDE1234F)"
                  value={formData.pan}
                  onChange={handleChange}
                  invalid={!!errors.pan}
                  feedback={errors.pan}
                />
              </CCol>
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="aadhar"
                  label="Aadhar Number"
                  placeholder="Enter 12-digit Aadhar"
                  value={formData.aadhar}
                  onChange={handleChange}
                  invalid={!!errors.aadhar}
                  feedback={errors.aadhar}
                />
              </CCol>
              <CCol md={4}>
                <CFormTextarea
                  name="address"
                  label="Address"
                  placeholder="Enter complete address"
                  value={formData.address}
                  onChange={handleChange}
                  invalid={!!errors.address}
                  feedback={errors.address}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Second Guarantor */}
        <CCard className="mb-4">
          <CCardHeader>Second Guarantor Details</CCardHeader>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="GuarantorName1"
                  label="Guarantor Name"
                  placeholder="Enter full name"
                  value={formData.GuarantorName1}
                  onChange={handleChange}
                  invalid={!!errors.GuarantorName1}
                  feedback={errors.GuarantorName1}
                />
              </CCol>
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="fathersName1"
                  label="Father's Name"
                  placeholder="Enter father's name"
                  value={formData.fathersName1}
                  onChange={handleChange}
                  invalid={!!errors.fathersName1}
                  feedback={errors.fathersName1}
                />
              </CCol>
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="mobileNumber1"
                  label="Mobile Number"
                  placeholder="Enter 10-digit mobile number"
                  value={formData.mobileNumber1}
                  onChange={handleChange}
                  invalid={!!errors.mobileNumber1}
                  feedback={errors.mobileNumber1}
                />
              </CCol>
            </CRow>

            <CRow className="mb-3">
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="pan1"
                  label="PAN Number"
                  placeholder="Enter PAN (e.g., ABCDE1234F)"
                  value={formData.pan1}
                  onChange={handleChange}
                  invalid={!!errors.pan1}
                  feedback={errors.pan1}
                />
              </CCol>
              <CCol md={4}>
                <CFormInput
                  type="text"
                  name="aadhar1"
                  label="Aadhar Number"
                  placeholder="Enter 12-digit Aadhar"
                  value={formData.aadhar1}
                  onChange={handleChange}
                  invalid={!!errors.aadhar1}
                  feedback={errors.aadhar1}
                />
              </CCol>
              <CCol md={4}>
                <CFormTextarea
                  name="address1"
                  label="Address"
                  placeholder="Enter complete address"
                  value={formData.address1}
                  onChange={handleChange}
                  invalid={!!errors.address1}
                  feedback={errors.address1}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Personal Reference */}
        <CCard className="mb-4">
          <CCardHeader>Personal Reference</CCardHeader>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="refName"
                  label="Reference Name"
                  placeholder="Enter reference person's name"
                  value={formData.refName}
                  onChange={handleChange}
                  invalid={!!errors.refName}
                  feedback={errors.refName}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="referencePhoneNumber"
                  label="Reference Phone Number"
                  placeholder="Enter 10-digit mobile number"
                  value={formData.referencePhoneNumber}
                  onChange={handleChange}
                  invalid={!!errors.referencePhoneNumber}
                  feedback={errors.referencePhoneNumber}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Professional Reference */}
        <CCard className="mb-4">
          <CCardHeader>Professional Reference</CCardHeader>
          <CCardBody>
            <CRow className="mb-3">
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="nameProfessional"
                  label="Professional Name"
                  placeholder="Enter professional reference name"
                  value={formData.nameProfessional}
                  onChange={handleChange}
                  invalid={!!errors.nameProfessional}
                  feedback={errors.nameProfessional}
                />
              </CCol>
              <CCol md={6}>
                <CFormInput
                  type="text"
                  name="phoneNumberProfessional"
                  label="Professional Phone Number"
                  placeholder="Enter 10-digit mobile number"
                  value={formData.phoneNumberProfessional}
                  onChange={handleChange}
                  invalid={!!errors.phoneNumberProfessional}
                  feedback={errors.phoneNumberProfessional}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          <CButton
            type="button"
            onClick={handleReset}
            style={{
              background: "linear-gradient(181deg, #000208, #333)",
              padding: "10px 20px",
            }}
            color="primary"
          >
            Reset
          </CButton>

          {loader ? (
            <Loader />
          ) : (
            <CButton
              style={{
                background: "linear-gradient(181deg, #000208, #333)",
                padding: "10px 20px",
              }}
              type="submit"
              color="primary"
            >
              Submit
            </CButton>
          )}
        </div>
      </CForm>
    </div>
  );
};

export default GuarantorReferences;
